export default "__VITE_ASSET__ur3iO9Qu__"